import { Box, Link, Typography } from '@mui/material';
import React from 'react';

export default function LegaleseLinks() {
  return (
    <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center' }}>
      <Link target="_blank" href="https://schedulink.io/terms-of-service"><Typography sx={{ color: 'black' }} variant='caption'>Terms Of Service</Typography></Link>
      <Link target="_blank" href="https://schedulink.io/privacy-policy"><Typography sx={{ color: 'black' }} variant='caption'>Privacy Policy</Typography></Link>
    </Box>
  );
}